import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";
import { apiFetch } from "./apiFetch";

/**
 * Participant-centric profile rows (one per user — not per event registration).
 * Optional event filters restrict to users registered for matching events.
 * Prefer `event_ids` when Status includes Expired (client-derived phase); otherwise `event_statuses`.
 * @param {{
 *   account_id: string,
 *   event_id?: string|null,
 *   event_ids?: string[]|null,
 *   event_statuses?: string[]|null,
 *   program_id?: string|null,
 *   attendance?: string|null,
 * }} params
 * @returns {Promise<object[]>}
 */
export async function fetchParticipantProfileDetails({
  account_id,
  event_id = null,
  event_ids = null,
  event_statuses = null,
  program_id = null,
  attendance = null,
} = {}) {
  if (!account_id) throw new Error("account_id is required");
  const body = { account_id };
  const eid = event_id != null ? String(event_id).trim() : "";
  if (eid && eid !== "__all__") body.event_id = eid;
  const ids = Array.isArray(event_ids)
    ? [...new Set(event_ids.map((id) => String(id || "").trim()).filter(Boolean))]
    : [];
  if (ids.length > 0) {
    body.event_ids = ids;
  } else if (Array.isArray(event_statuses) && event_statuses.length === 1) {
    body.event_statuses = event_statuses;
  }
  const pid = program_id != null ? String(program_id).trim() : "";
  if (pid) body.program_id = pid;
  const att = attendance != null ? String(attendance).trim() : "";
  if (att) body.attendance = att;
  const resp = await apiFetch(serverInfo.serverUrl + "/getParticipantProfileDetails", {
    method: "POST",
    body: JSON.stringify(body),
  });
  checkResponse(resp);
  const data = await resp.json();
  return Array.isArray(data) ? data : [];
}
